import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const LandingNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: '#2E7D32', // Casante green
        borderBottom: '1px solid rgba(255, 255, 255, 0.12)'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          {/* Logo/Brand */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src="/casante-logo.png"
              alt="Casante Checks logo"
              sx={{
                width: 28,
                height: 28,
                mr: 1,
                borderRadius: '50%',
              }}
            />
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                fontFamily: '"Montserrat", sans-serif',
                fontWeight: 700,
                color: '#fff',
                cursor: 'pointer'
              }}
              onClick={() => navigate('/')}
            >
              casanté
            </Typography>
          </Box>

          {/* Navigation Links */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              color="inherit"
              onClick={() => navigate('/how-it-works')}
              sx={{
                color: isActive('/how-it-works') ? '#A5D6A7' : '#fff',
                fontWeight: isActive('/how-it-works') ? 'bold' : 'normal',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              How It Works
            </Button>
            
            <Button
              color="inherit"
              onClick={() => navigate('/pricing')}
              sx={{
                color: isActive('/pricing') ? '#A5D6A7' : '#fff',
                fontWeight: isActive('/pricing') ? 'bold' : 'normal',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              Pricing
            </Button>

            <Button
              color="inherit"
              onClick={() => navigate('/signup')}
              sx={{
                color: isActive('/signup') ? '#A5D6A7' : '#fff',
                fontWeight: isActive('/signup') ? 'bold' : 'normal',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              Sign Up
            </Button>

            <Button
              variant="outlined"
              onClick={() => navigate('/login')}
              sx={{
                color: '#fff',
                borderColor: '#fff',
                ml: 1,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: '#A5D6A7'
                }
              }}
            >
              Login
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default LandingNavigation;
